import React, { useState } from 'react'
import { Popover, Button } from 'antd';
import { SPANISH_ITEM_LOWER, SPANISH_ITEM_UPPER } from "utils/config/reference"
import color from 'utils/constants/color';
import styled from "styled-components"
import * as Sentry from '@sentry/react';
const Wrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    z-index: 2;
`;

const AccentGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 5px;
`;

const AccentRow = styled.div`
    display: grid;
    grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
    gap: 6px;
`;

const AccentOption = styled(Button)`
    min-width: 36px;
`;
export default function Acent({ inputRef, setValue, style = {}, isDisabled = false , className=""}) {
    const [upperMenuVisible, setUpperMenuVisible] = useState(false);
    const [lowerMenuVisible, setLowerMenuVisible] = useState(false);

    const handleUpperMenuClick = (accent) => {
        insertAccent(accent);
        setUpperMenuVisible(false); // Hide upper menu after selection
    };

    const handleLowerMenuClick = (accent) => {
        insertAccent(accent);
        setLowerMenuVisible(false); // Hide lower menu after selection
    };

    const insertAccent = (accent) => {
        if (!inputRef) {
            return;
        }
        const textarea = inputRef.current ? inputRef.current : inputRef;
        if (!textarea) return;

        try {
            const { selectionStart, selectionEnd, value: inputValue } = textarea;
            const newInputValue = inputValue.substring(0, selectionStart) + accent + inputValue.substring(selectionEnd);

            updateTextareaValue(textarea, newInputValue);
            dispatchInputEvent(textarea);
            updateCursorPosition(textarea, selectionStart + accent.length);
        } catch (error) {
            Sentry.captureException(`136 Error in accent insertion: ${error}`);
        }
    };

    const updateTextareaValue = (textarea, newValue) => {
        textarea.value = newValue;
        if (setValue) {
            setValue(newValue);
        }
    };

    const dispatchInputEvent = (textarea) => {
        const event = document.createEvent('Event');
        event.initEvent('input', true, true);
        textarea.dispatchEvent(event);
    };

    const updateCursorPosition = (textarea, newPosition) => {
        setTimeout(() => {
            textarea.setSelectionRange(newPosition, newPosition);
            textarea.focus();
        }, 0);
    };

    const createRows = (items) => {
        const rowSize = 3;
        const rows = [];
        for (let index = 0; index < items.length; index += rowSize) {
            rows.push(items.slice(index, index + rowSize));
        }
        return rows;
    };

    const renderAccentContent = (items, onClick) => (
        <AccentGrid>
            {createRows(items).map((rowItems) => (
                <AccentRow key={rowItems.join('')} $columns={rowItems.length}>
                    {rowItems.map((item) => (
                        <AccentOption key={item} size="small" onClick={() => onClick(item)}>
                            {item}
                        </AccentOption>
                    ))}
                </AccentRow>
            ))}
        </AccentGrid>
    );

    return (
        <Wrapper className={className} style={style}>
            <Popover
                trigger="click"
                placement="bottomLeft"
                open={isDisabled ? false : upperMenuVisible}
                onOpenChange={(flag) => setUpperMenuVisible(flag)}
                content={renderAccentContent(SPANISH_ITEM_UPPER, handleUpperMenuClick)}
                getPopupContainer={() => document.body}
                styles={{ root: { zIndex: 9999 }, body: { padding: 5 } }}
            >
                <Button disabled={isDisabled} size="small" type="primary" style={{ backgroundColor: color.green100, borderColor: color.green100 }} onClick={() => setUpperMenuVisible(!upperMenuVisible)}>
                    Á
                </Button>
            </Popover>
            <Popover
                trigger="click"
                placement="bottomLeft"
                open={isDisabled ? false : lowerMenuVisible}
                onOpenChange={(flag) => setLowerMenuVisible(flag)}
                content={renderAccentContent(SPANISH_ITEM_LOWER, handleLowerMenuClick)}
                getPopupContainer={() => document.body}
                styles={{ root: { zIndex: 9999 }, body: { padding: 5 } }}
            >
                <Button disabled={isDisabled} size="small" type="primary" style={{ marginLeft: 2, backgroundColor: color.green100, borderColor: color.green100 }} onClick={() => setLowerMenuVisible(!lowerMenuVisible)}>
                    á
                </Button>
            </Popover>
        </Wrapper>
    )
}
